import { h, Component } from 'preact'
import TermsAPI from '../api/TermsAPI'
import ErrorMessage from '../components/ErrorMessage'
import SelectLoader from '../components/SelectLoader'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class SelectFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      terms: [],
      error: false,
      isLoading: true,
      width: 'auto'
    }

    this.handleTerm = this.handleTerm.bind(this)
  }

  componentDidMount() {
    this.fetchTerms()

    this.setState({
      defaultValue: this.props.defaultOption,
      selected: false
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentValue !== this.props.currentValue) {
      this.setWidth()
    }
  }

  fetchTerms() {
    this.setState({ isLoading: true })

    TermsAPI.all(this.props.taxonomy)
      .then(response => response.json())
      .then(data => {
        this.setState(
          {
            terms: [...this.state.terms, ...data],
            isLoading: false
          },
          () => {
            this.setWidth()
          }
        )
      })
      .catch(error => {
        this.setState({
          error: true,
          isLoading: false
        })
      })
  }

  handleTerm(e) {
    this.setState(
      {
        selected: e.target.value !== ''
      },
      () => {
        this.setWidth()
      }
    )

    this.props.onSelectTerm(e.target.value, this.props.taxonomy)
  }

  generateOptions(tax) {
    let options = []

    // default option
    options.push(
      <option
        value=""
        key={tax}
        disabled={this.props.postsLoading ? true : false}
        dangerouslySetInnerHTML={{ __html: this.state.defaultValue }}
      />
    )

    // make an option for each branch
    this.state.terms.map(term => {
      // skip term if it has no posts
      if (term.count === 0) return false

      return options.push(
        <option
          value={term.id}
          key={term.id}
          dangerouslySetInnerHTML={{ __html: term.name }}
          data-label={term.name}
        />
      )
    })
    return options
  }

  // Function to adjust the width of a select
  setWidth() {
    const optionEle = document.getElementById(`${this.props.taxonomy}-hidden`)
    const width = optionEle.offsetWidth // padding width or arrows
    this.setState({ width: `${width}px` })
  }

  findOption(items, value) {
    let foundItem = false
    ;(items || []).map((item, index) => {
      if (item.id == value) {
        foundItem = item.name
      }
    })
    return foundItem
  }

  render() {
    let { error, isLoading } = this.state

    const selectedObj = this.findOption(
      this.state.terms,
      this.props.currentValue
    )
    const selectedValue = selectedObj ? selectedObj : this.props.defaultOption

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return (
        <div className="c-select-loader">
          <SelectLoader />
        </div>
      )
    }

    return (
      <div className="c-housing-select-filter">
        <select
          value={this.props.currentValue}
          onChange={this.handleTerm}
          disabled={this.props.postsLoading ? true : false}
          className={`c-housing-select-filter__select ${
            this.props.currentValue !== '' ? 'active' : ''
          }`}
          style={{ width: this.state.width || 'auto' }}
        >
          {this.generateOptions(this.props.taxonomy)}
        </select>
        <div className="c-housing-select-filter__hidden-container">
          <span
            style={{ visibility: 'hidden' }}
            className="c-housing-select-filter__hidden"
            id={`${this.props.taxonomy}-hidden`}
          >
            {selectedValue}
          </span>
        </div>
      </div>
    )
  }
}

export default SelectFilter



// WEBPACK FOOTER //
// ./src/js/housing/containers/SelectFilter.js